<template>
  <div
    class="w-100 bg-white followUp_Container"
  >
    <div class="followUp_Container__Content">
      <h2 class="text-primary">
        Re-assess your gut health with a follow-up test
      </h2>
      <p>
        Your gut microbiome changes with time. Re-test to stay on track!
      </p>
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="openFollowupKitPage"
      >
        Explore
      </button>
    </div>
    <div
      class="followUp_Container__ImageSection"
    >
      <div class="followUp_Container__ImageSection-image" />
    </div>

  </div>
</template>
<script>
export default {
  methods: {
    openFollowupKitPage() {
      window.open('https://navipointhealth.com/gut-balance-program/?us-buy=true', '_blank')
    },
  },
}
</script>
<style lang="scss">

.followUp_Container{

  @media (min-width: 1025px){
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  height: 15rem;
  }
  @media (min-width: 768px) and (max-width: 1025px){
    display: grid;
    grid-template-columns: 2fr 1fr;
    height: 15rem;
  }
  @media (max-width: 769px){
    display: flex;
    flex-direction: column;
    height: 23rem;
    border-radius: 10px;
  }
  &__Content{
    @media (min-width: 1025px){
    padding: 2.5rem;
    height: 15rem;
    }
    @media (min-width: 768px) and (max-width: 1025px){
    padding: 1rem;
    height: 15rem;
  }
    @media (max-width: 769px){
      padding: 2rem;
      height: 16rem;
         }

  p{
  margin-bottom: 1.5rem;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #0a6eca;

  }
    }
    &__ImageSection{
      display: flex;
      align-items: center;
      justify-content: right;
      overflow: hidden;

      &-image{
        position: absolute;
        background-image: url('../assets/images/followupCard-mobile.png');
        background-repeat: no-repeat;
        background-size: contain;
         @media (min-width: 1025px){
        height: 15rem;
        width: 27rem;
        background-image: url('../assets/images/followupCard.png');
        margin-right: 2rem;
         }
        @media (min-width: 768px) and (max-width: 1025px){
          height: 15rem;
          width: 20rem;
        }
         @media (max-width: 769px){
          height: 14rem;
          width: 18rem;
         }
        background-position: right;

      }
    }

}

</style>
